var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#111111;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path880",
    className: "cls-1",
    d: "M9.98572,184.29369l-1.525-.66489c27.90163-15.05467,48.9936-28.38663,79.18255-43.15538,14.96159,22.358,24.56947,38.78655,38.10533,66.85608C160.74675,141.65641,200.37184,65.06676,286.45713,24.689c-2.77761,36.27184-3.38637,64.27133,5.08218,95.57564C224.3388,153.638,170.26924,212.13967,131.30184,274.15774L130.589,275.311C94.65438,233.94547,58.66991,205.79151,9.98572,184.29369Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.5c33a122dc57a1b781ecbcf9c6919f6b.svg";
export { ForwardRef as ReactComponent };